import { ChartBarIcon } from "@heroicons/react/outline";

import EntityVersionAnalyticsSheetContent from "./EntityVersionAnalyticsSheetContent";
import type { EntityVersionAnalyticsQuerySnapshot, EntityVersionAnalyticsVariant } from "./types";

import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";

export { default as OpenAnalyticsButton } from "./OpenAnalyticsButton";
export { snapshotStructuredSearchQuery } from "./snapshotStructuredSearchQuery";
export type { EntityVersionAnalyticsQuerySnapshot, EntityVersionAnalyticsVariant } from "./types";

interface EntityVersionAnalyticsSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  querySnapshot: EntityVersionAnalyticsQuerySnapshot | null;
  variant: EntityVersionAnalyticsVariant;
  /** Remount key so each open gets a fresh copied query store. */
  contentKey?: string | number;
}

const EntityVersionAnalyticsSheet = ({
  open,
  onOpenChange,
  querySnapshot,
  variant,
  contentKey,
}: EntityVersionAnalyticsSheetProps) => (
  <Sheet onOpenChange={onOpenChange} open={open}>
    <SheetContent
      side="right"
      className="flex h-full w-full max-w-[96vw] flex-col gap-0 overflow-hidden p-0 sm:min-w-[min(720px,96vw)] sm:max-w-[1400px]"
    >
      <SheetHeader className="shrink-0 pb-0">
        <SheetTitle className="flex h-[36px] items-center gap-2 text-2xl font-semibold">
          <ChartBarIcon className="max-h-5 min-h-5 min-w-5 max-w-5 text-gray-400" />
          Analytics
        </SheetTitle>
      </SheetHeader>
      <div className="flex min-h-0 flex-1 flex-col gap-1 overflow-hidden px-4 pb-6 pt-4">
        {querySnapshot ? (
          <EntityVersionAnalyticsSheetContent
            key={contentKey ?? "entity-version-analytics"}
            querySnapshot={querySnapshot}
            variant={variant}
          />
        ) : null}
      </div>
    </SheetContent>
  </Sheet>
);

export default EntityVersionAnalyticsSheet;
